import config from 'app-self-support-order/config'

const crmThirdPartyShopApi = `${config.apiHost}/oem-crm_third_party_shop`

export default {
    getShopList: {
        url: `${crmThirdPartyShopApi}/api/shop`,
        type: 'GET',
    },

    createShop: {
        url: `${crmThirdPartyShopApi}/api/shop`,
        type: 'POST',
    },

    editShop: {
        url: `${crmThirdPartyShopApi}/api/shop/{shop_id}`,
        type: 'PUT',
    },
}
